export default __webpack_public_path__ + "static/media/Notification3_1.e45d855b.mp3";